<template>
  <layout-basic>
    <section class="banner-text padding-bottom why-improve">
      <v-row no-gutters>
        <v-col class="banner-wrapper">
          <!-- Shape Background -->
          <div class="why-improve-shape-background">
            <img
              class="why-improve-background-image border-bottom"
              :src="
                getImageSource(
                  'improve-main-banner-gradient-background.png',
                  'homepage/banner'
                )
              "
            />

            <img
              v-if="screenSize === 'desktop' || screenSize === 'mobile'"
              class="why-improve-banner-orange-image"
              :src="
                getImageSource(
                  'total-business-compliance-orange-rectangle.png',
                  'why-improve/banner'
                )
              "
            />
            <img
              class="why-improve-banner-blue-image"
              :src="
                getImageSource(
                  'total-compliance-courses-blue-rectangle.png',
                  'why-improve/banner'
                )
              "
            />
          </div>
          <v-container class="banner-img-text-wrapper pb-0">
            <!-- Banner Left Wrapper -->
            <div class="why-improve-banner-left-wrapper">
              <div id="main-banner-wrapper">
                <img
                  class="why-improve-rounded-rectangle-image"
                  :src="
                    getImageSource(
                      'main-banner-rounded-rectangle.png',
                      'homepage/banner'
                    )
                  "
                />
                <div class="banner-text-overlay">
                  UPSKILL, TRAIN AND INDUCT STAFF
                </div>
              </div>
              <div class="why-improve-banner-main-title">
                Tailor Training to your Business
              </div>
              <div class="banner-sub-text">
                IMPROVE offers unlimited access to a wide range of training
                courses. Add your own documents, ensuring a tailored learning
                experience that meets your organisation's unique objectives.
              </div>
              <a
                id="request-demo-btn"
                href="/watch-demo"
                class="request-demo-btn mt-8 d-flex align-self-center"
              >
                Watch the 5-minute demo
              </a>
            </div>

            <!-- Microlearning Image -->
            <img
              class="why-improve-microlearning-image"
              :src="
                getImageSource(
                  'tailor-training-to-your-business-with-improves-courses.png',
                  'why-improve/banner'
                )
              "
            />
          </v-container>
        </v-col>
      </v-row>
    </section>
    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="compare" />
      </v-container>
    </section>
    <!-- Steve's Why IMPROVE testimonial (16 Sep 2026), verbatim. -->
    <quote-row :quotes="pageQuotes" />
    <section class="improve-customers">
      <v-row class="text-center mt-10" no-gutters>
        <v-container style="padding: 0 25px">
          <div class="carousel-title">
            Organisations across multiple sectors using IMPROVE
          </div>
          <v-col class="pa-0" cols="12" md="12" p>
            <VueSlickCarousel v-bind="imageCarousel">
              <template #prevArrow="arrowOption">
                <div class="custom-carousel-button">
                  <span><i class="fa fa-chevron-left"></i></span>
                </div>
              </template>
              <template #nextArrow="arrowOption">
                <div class="custom-carousel-button">
                  <span><i class="fa fa-chevron-right"></i></span>
                </div>
              </template>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/advoacy-focus.png"
                  class="img-fluid"
                  alt="Advocacy Focus Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/east-midlands-chamber.png"
                  class="img-fluid"
                  alt="East Midlands Chamber Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/eden-holistic-pet-foods.png"
                  class="img-fluid"
                  alt="Eden Holistic Pet Foods Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/effectech.png"
                  class="img-fluid"
                  alt="Effectech Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/hr-central-human-resources-consultancy.jpg"
                  class="img-fluid"
                  alt="HR Central Human Resources Consultancy Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/hope-nottingham.png"
                  class="img-fluid"
                  alt="Hope Nottingham Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/la-micro.png"
                  class="img-fluid"
                  alt="La Micro Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/laceys-solicitors.png"
                  class="img-fluid"
                  alt="Laceys Solicitors Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/m-j-r.png"
                  class="img-fluid"
                  alt="M J R Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/people-value.png"
                  class="img-fluid"
                  alt="People Value Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/pilkington.png"
                  class="img-fluid"
                  alt="Pilkington Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/tevva.png"
                  class="img-fluid"
                  alt="Tevva Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/APK_Group_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="APK Group Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/3SC_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="3SC Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Advonet_Group_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="Advonet Group Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Boostwork_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="Boostwork Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/BPX_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="BPX Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Carter_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="Carter Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/China-Britain-Business-Council-IMPROVE-Customer.png"
                  class="img-fluid"
                  alt="China Britain Business Council Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Council-of-Deans-of-Heath-IMPROVE-Customer.png"
                  class="img-fluid"
                  alt="Council of Deans of Health Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Devon-Community-Foundation-IMPROVE-Customer.jpg"
                  class="img-fluid"
                  alt="Devon Community Foundation Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/IP-Group-IMPROVE-Customer.png"
                  class="img-fluid"
                  alt="IP Group Approved IMPROVE partner"
                />
              </div>
            </VueSlickCarousel>
          </v-col>
        </v-container>
      </v-row>
    </section>
    <hr />
    <section style="margin-top: 40px;">
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container>
            <div class="why-improve-title text-center">
              <h2>How does your Business Train its Employees?</h2>

              <span
                >IMPROVE is your cost-effective solution for training,
                development and compliance management.</span
              >

              <p>
                Gain access to a wide range of off-the-shelf courses
                specifically tailored to address compliance, staff induction and
                more. You can also effortlessly upload and integrate your own
                documents to courses for a truly customised learning experience.
              </p>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" align-self="center" no-gutters>
          <v-container style="padding: 0 15px;">
            <img
              class="compliance-training-overlay"
              :src="
                getImageSource(
                  'upload-your-own-documents-pink-rectangle.png',
                  'why-improve/staff-dev'
                )
              "
            />

            <div class="compliance-training-wrapper">
              <div class="compliance-training-content">
                <h1>Upload Your Own Documents</h1>

                <span>Training material specific to your business. </span>

                <p>
                  <b>IMPROVE</b> allows you to
                  <b>upload your own documents,</b> ensuring that your
                  <b>training material </b> is
                  <b>is specific to your industry,</b> processes, and
                  <b>values. </b>
                </p>

                <h1>Upload Your Own Documents</h1>

                <span>Keep up to date with regulatory requirements. </span>

                <p>
                  Ensure your <b>organisation </b> remains
                  <b>compliant. </b> Our <b>extensive library </b> of
                  <b>compliance-focused courses</b> range from <b>GDPR </b>to
                  <b>cyber security </b> and <b>sexual harassment. </b>
                </p>
              </div>
              <img
                class="compliance-training-image"
                :src="
                  getImageSource(
                    'business-compliance-course-playlists.png',
                    'why-improve/staff-dev'
                  )
                "
              />
            </div>
          </v-container>
        </v-col>
      </v-row>
    </section>
    <section style="position: relative; margin-bottom: 40px;">
      <img
        v-if="screenSize === 'desktop' || screenSize === 'mobile'"
        class="induct-img-overlay"
        :src="
          getImageSource(
            'staff-development-courses-grey-rectangle.png',
            'why-improve/staff-dev'
          )
        "
      />
      <v-row no-gutters>
        <v-col cols="12" align-self="center" no-gutters>
          <v-container style="padding: 0 15px;">
            <div class="staff-dev-wrapper">
              <img
                class="induct-image pe-md-5"
                :src="
                  getImageSource(
                    'courses-to-develop-your-staff.png',
                    'why-improve/staff-dev'
                  )
                "
              />
              <div class="staff-dev-content ps-md-5">
                <h1>Staff Development</h1>

                <span>Upskill your existing employees. </span>

                <p>
                  <b>Equip your managers </b> with the
                  <b>essential skills</b> and <b>knowledge</b> to
                  <b>effectively lead, motivate, </b> and
                  <b>inspire their teams</b> with our range of
                  <b>training courses. </b>
                </p>

                <h1>24/7 Course Access</h1>

                <span>Access your course library from anywhere. </span>

                <p>
                  With access <b>24/7 on any device,</b> your team can learn at
                  a time that suits them. Access our training courses
                  <b>from any device:</b> desktop, laptop, tablet, or
                  smartphone.
                </p>
              </div>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </section>
    <section style="padding-bottom: 70px;">
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container style="padding: 0 15px;">
            <div class="more-benefit-title text-center mt-15">
              <img
                src="/static/homepage/choose/why-choose-improve-for-your-business.png"
              />

              <h2>More Benefits of IMPROVE...</h2>

              <p>
                Take your business to the next level.
              </p>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <v-container class="choose-cards">
        <v-row class="choose-cards">
          <v-col cols="12" sm="12" md="4">
            <div class="training-card">
              <img
                src="/static/why-improve/benefits/track-staff-progress-training.png"
              />
              <h2>Track Progress</h2>
              <p>
                Gain <b> actionable insights </b>into
                <b>staff progress, course completion rates,</b> and
                <b>engagement levels. </b>
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>
          <v-col cols="12" sm="12" md="4">
            <div class="scalable-card">
              <img
                src="/static/why-improve/benefits/training-solution-user-friendly-interface.png"
              />
              <h2>User-Friendly Interface</h2>
              <p>
                Irrespective of your staff’s
                <b>technical expertise, learning becomes a breeze</b> with
                <b>IMPROVE.</b>
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>
          <v-col cols="12" sm="12" md="4">
            <div class="dedicated-card">
              <img
                src="/static/why-improve/benefits/scalable-business-training-solution.png"
              />
              <h2>Scalable Solution</h2>
              <p>
                Our <b>future-proof</b> solution <b>scales effortlessly</b> as
                your <b>organisation grows.</b>
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>

          <v-col cols="12" sm="12" md="4">
            <div class="courses-card">
              <img
                src="/static/why-improve/benefits/group-staff-for-training.png"
              />
              <h2>Create Groups</h2>
              <p>
                <b>Group staff</b> by <b>roles and responsibilities</b> and
                <b>assign relevant training materials</b> and courses.
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>

          <v-col cols="12" sm="12" md="4">
            <div class="cost-card">
              <img
                src="/static/why-improve/benefits/cost-saving-training-solution.png"
              />
              <h2>Time & Cost Savings</h2>
              <p>
                <b>Streamline your training</b> and
                <b>compliance processes</b> with IMPROVE’s
                <b>automated features.</b>
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>

          <v-col cols="12" sm="12" md="4">
            <div class="platform-card">
              <img
                src="/static/why-improve/benefits/business-training-and-support.png"
              />
              <h2>Dedicated Support</h2>
              <p>
                From <b>implementation</b> to <b>ongoing support, </b>we're here
                to assist you at <b>every step.</b>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <hr />
    <section style="margin-top: 50px;">
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container>
            <div class="testimonial-title text-center">
              <img
                src="/static/homepage/testimonial/improve-customer-testimonials.png"
              />

              <h2>Customer Testimonials</h2>

              <p>
                What our customers say about IMPROVE
              </p>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <v-container>
        <VueSlickCarousel v-bind="testimonialCarousel">
          <div class="testimonial-item">
            <!-- <img
              src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
              class="testimonial-placeholder-circle"
            /> -->
            <div class="testimonial-card">
              <div>
                <h2>“The Best Onboarding Process”</h2>
                <p>
                  “New staff have been in ‘awe’ of our onboarding process which
                  is all centrally delivered via IMPROVE. We have found it to be
                  the best onboarding process we have experienced.”
                </p>
              </div>

              <img
                src="/static/homepage/testimonial/advocacy-focus-testimonial.png"
                alt="Advocacy Focus Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
              src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
              class="testimonial-placeholder-circle"
            /> -->
            <div class="testimonial-card">
              <div>
                <h2>“Comprehensive & Easy to Access”</h2>
                <p>
                  “It’s authoritative, accurate, comprehensive, and easy to
                  access. It removes the stress of training delivery from
                  business owners, knowing that they can review what their staff
                  are learning.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/smart-space-testimonial.png"
                alt="Smart Space Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
              src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
              class="testimonial-placeholder-circle"
            /> -->
            <div class="testimonial-card">
              <div>
                <h2>“Seamless Training Process”</h2>
                <p>
                  “The user-friendly interface has been built to ensure that
                  everyone can use it with ease, and the courses are tailored to
                  suit each team member's learning needs.”
                </p>
              </div>

              <img
                src="/static/homepage/testimonial/eden-holistic-pet-foods-testimonial.png"
                alt="Eden Holistic Pet Foods Approved IMPROVE partner"
              />
            </div>
          </div>
        </VueSlickCarousel>
      </v-container>
    </section>
    <section class="animate-cat-on-scroll">
      <v-row no-gutters>
        <v-col no-gutters>
          <!-- Shape Background -->
          <div class="demo-background">
            <img
              class="demo-background-image"
              :src="
                getImageSource(
                  'business-training-solution-free-trial.jpg',
                  'why-improve/demo'
                )
              "
            />
            <img
              class="demo-background-cat"
              :src="
                getImageSource(
                  'training-courses-for-smes-with-improve.png',
                  'homepage/demo'
                )
              "
            />
            <div class="demo-content">
              <h2 style="color: #ffffff !important;">Experience IMPROVE</h2>
              <p style="color: #E7F8FF !important;">
                Discover how IMPROVE can enhance training, induction, and
                compliance management within your business.
              </p>
              <a
                :href="experienceHref"
                class="book-demo-btn"
                rel="noopener"
              >
                Experience IMPROVE
              </a>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import DemoVideo from '@/components/DemoVideo.vue';
import QuoteRow from '@/components/marketing/QuoteRow.vue';
import { MANUFACTURING_EASY_TO_ADMINISTER, TRILOGY_SIMPLER } from '@/data/testimonials';
import { screensize } from '../../utils/screensize';
import { IMPROVE_CONFIG } from '@/config.js';
import { getExperienceHref } from '@/config/ctas';
// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'why-improve',
  metaInfo() {
    return {
      title: "Why Choose IMPROVE: Tailored Training for SMEs",
      meta: [
        // Meta Description
        { name: "description", content: "Discover why businesses choose IMPROVE: Tailor training to your organisation, track progress, and enjoy a scalable, user-friendly solution for staff development." },
        
        // Keywords
        { name: "keywords", content: "IMPROVE Training, Tailored Business Training, Staff Development, Compliance Training, Training Solution for SMEs, Scalable Learning Platform, User-Friendly LMS" },
        
        // Open Graph / Facebook Tags
        { property: "og:title", content: "Why Choose IMPROVE: Tailored Training for SMEs" },
        { property: "og:description", content: "IMPROVE offers tailored training for SMEs with features like document uploads, compliance management, progress tracking, and a user-friendly platform." },
        { property: "og:image", content: "https://www.improve.online/static/SEO.png" },
        { property: "og:url", content: `https://www.improve.online/why-improve` },

        // Twitter Meta Tags
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: "Why Choose IMPROVE: Tailored Training for SMEs" },
        { name: "twitter:description", content: "IMPROVE is a complete business training solution for SMEs, offering tailored learning, compliance-focused courses, and progress tracking for staff." },
        { name: "twitter:image", content: "https://www.improve.online/static/SEO.png" },
      ],
      link: [
        // Canonical URL
        { rel: "canonical", href: `https://www.improve.online/why-improve` },
      ],
    };
  },
  components: {
    LayoutBasic,
    VueSlickCarousel,
    DemoVideo,
    QuoteRow,
  },
  computed: {
    experienceHref() {
      return getExperienceHref();
    },
  },
  data() {
    return {
      pageQuotes: [MANUFACTURING_EASY_TO_ADMINISTER, TRILOGY_SIMPLER],
      screenSize: currentScreenSize,
      imageCarousel: {
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 599,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 350,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      testimonialCarousel: {
        infinite: true,
        autoplay: true,
        dots: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      directUrl: IMPROVE_CONFIG.DIRECT_URL,
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    // Listen for scroll events
    window.addEventListener('scroll', this.handleScroll);
    // Initial check when the component mounts
    this.handleScroll();
  },
  methods: {
    // Method to handle screen size changes
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
    // Method to dynamically generate the image source based on screen size
    getImageSource(imageName, filepath) {
      return `/static/${filepath}/${this.screenSize}/${imageName}`;
    },
    handleScroll() {
      const catElemet = this.$el.querySelector('.animate-cat-on-scroll');

      const catRect = catElemet.getBoundingClientRect();
      const catInViewport =
        catRect.top >= 0 &&
        catRect.left >= 0 &&
        catRect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        catRect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      if (catInViewport) {
        catElemet.classList.add('animate');
      }
    },
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);

    // Remove event listener when component is destroyed
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
